import React from 'react'
import Header from '../../../../shared/sections/Header'
import Annotation from '../../../../shared/sections/FirstView/Annotation'
import { kansaiConfig } from '../../config'
import { useJobsData } from '../../../../shared/hooks/useJobsData'
import { useConfigWithDynamicData } from '../../../../shared/hooks/useConfigWithDynamicData'
import styles from './KansaiSpLandingPage.module.css'
import VerticalEntryForm from '../../../../shared/forms/VerticalEntryForm'
import { StepProvider } from '@/components/Context/StepContext'
import { KansaiSpLandingPageProps } from './types'
import { useAbTestGtm } from '@/components/utils/abTest'
import { SlimFirstView } from '@/components/Common/SlimFirstView'
import { CompanyLogoStrip } from '@/components/Common/CompanyLogoStrip'
import Footer from '../../../../shared/sections/Footer/Footer'

const KansaiSpLandingPage: React.FC<KansaiSpLandingPageProps> = ({ prefectures }) => {
    const { dataViewLabel } = useAbTestGtm()
    const { jobs, mapping, error } = useJobsData(kansaiConfig)

    const configWithDynamicData = useConfigWithDynamicData({
        areaConfig: kansaiConfig,
        jobs,
        mapping
    })

    if (error) {
        console.error('関西エリア求人データ読み込みエラー:', error)
    }

    return (
        <div className={styles.kansaiSpLandingPage}>
            <StepProvider
                initialFormData={{
                    preferLineContact: true,
                    agreeTerms: true
                }}
                initialTouchedFields={{
                    preferLineContact: true,
                    agreeTerms: true,
                    channel: true
                }}
            >
                <Header
                    id='renewal_top'
                    dataViewLabel={dataViewLabel('HD')}
                />
                <SlimFirstView dataViewLabel={dataViewLabel('CT_FirstView')} />
                <CompanyLogoStrip />
                <VerticalEntryForm
                    prefectures={prefectures}
                    config={configWithDynamicData}
                />
                <Annotation />
                <Footer />
            </StepProvider>
        </div>
    )
}

export default KansaiSpLandingPage
